var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4C17 5.10457 16.1046 6 15 6H9C7.89543 6 7 5.10457 7 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50055 4.06287C4.63766 4.2847 4 5.06788 4 6V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V6C20 5.06788 19.3623 4.28469 18.4994 4.06287C18.4659 5.96686 16.912 7.5 15 7.5H9C7.088 7.5 5.53409 5.96686 5.50055 4.06287ZM16.8021 14.251H13.0339C12.7564 14.251 12.5315 14.0261 12.5315 13.7486V9.98038C12.5315 9.56416 12.8709 9.2208 13.2825 9.2825C15.4561 9.60828 17.1742 11.3264 17.5 13.5C17.5617 13.9116 17.2183 14.251 16.8021 14.251ZM11.2706 19.5C8.91203 19.5 7 17.588 7 15.2294C7 13.1267 8.51962 11.3789 10.5205 11.0244C10.9304 10.9518 11.2706 11.2961 11.2706 11.7124V14.4757C11.2706 14.8919 11.6081 15.2294 12.0243 15.2294H14.7876C15.2039 15.2294 15.5482 15.5696 15.4756 15.9795C15.1211 17.9804 13.3733 19.5 11.2706 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieReport);
export default __webpack_public_path__ + "static/media/pie-report.6c4190c43492107d251433685d8349e8.svg";
export { ForwardRef as ReactComponent };